module.exports = __webpack_public_path__ + "static/about-img-1f1cdb2d208627140e3a80f23a673528.jpg";